import api from "../index";

export const GetGenerateCommissionApi = (params) => api.get(`ibusermaster/ib-commission-generate-withdraw?${params}`);
export const GetGenerateCommissionCalculationApi = (userId, params) => api.get(`ibusermaster/get-ib-commision-calculation/${userId}?${params}`);
export const GetWithdrawCommissionApi = (params) => api.get(`ibusermaster/ib-commission-generate-withdraw?${params}`);
export const DepositReminderLogApi = (params) => api.get(`admin/get-all-deposit-reminder-log?${params}`);
export const GetIBCommissionReportApi = (params) => api.get(`ibusermaster/ib-commission-details?${params}`);

export const CommissionRollBackApi = (data) => api.patch(`IBRollBack/IB_Commission_RollBack-From-History`, data);
export const GetGenerateCommissionCalculationrollbackApi = (IbUserId, params) => api.get(`IBMaster/GetIb-CommisionCalculation/${IbUserId}?${params}`);




